import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Service List',
  path: '/homenet/servicelist',
  redirect: '/homenet/servicelist/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Available Service List',
      'path': 'list',
      'meta': {
        'label': 'list'
      },
      'component': lazyLoading('homenet/ServiceInfo')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/serviceinfo.js